export default __webpack_public_path__ + "static/media/whatsapp.c75084c4.png";